<template>
    <div>

     <v-container>
     		<!-- Form -->
		<v-card>
			<v-card-title>
				<span class="headline">{{ formTitle }}</span>
			</v-card-title>
			<v-form v-model="valid" ref="form" lazy-validation>
				<v-card-text>
					<v-container grid-list-md>
						<v-layout wrap>
							
							<v-flex xs12 sm4 md6>
								 <v-text-field label="Status Name" v-model="formSchema.name" :rules="[v => !!v || 'Field is required']" required></v-text-field>
							</v-flex>

							</v-flex>

						</v-layout>
					</v-container>

				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue darken-1" flat @click.native="resetForm" >Reset</v-btn>
					<v-btn color="blue darken-1" flat @click.native="validateBeforeSubmit">Save</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
		<!-- /Form -->  
     </v-container>
      
    </div>
</template>

<script>
const commonService = require('../../../services/common.service');

import {preFix} from '../../../vuex/api'
import Axios from 'axios'
export default {
    props:['formSchema'],
    data: () => ({
      valid: true,
    }),

    computed: {
      formTitle () {
        return this.formSchema.id > 0 ? 'Update Procurement Status' : 'New Procurement Status'
      },
    },

    created () { },
   
    methods: {
      validateBeforeSubmit(e) {
        var formSchema = this.formSchema
        var root = this

        if (this.$refs.form.validate()) {
          if ( formSchema.id > 0 )
          {            
              commonService.updateFormData(this.formSchema, 'proc_status').then(res => {
                if(res.status == 1){
                this.message ='Data updated successfully!';
                this.snackbar = true
                this.formSchema = {}
                this.$emit('reloadData')
							}
						});
          }
          else
          {            
            commonService.insertFormData(this.formSchema, 'proc_status').then(res => {
              if(res.status == 1){
                this.message ='Data created successfully!';
                this.snackbar = true
                this.formSchema = {}
                this.$emit('reloadData')
							}
						});
          }
        }  
      },

      resetForm()
      {
        this.$refs.form.reset();
      },

      close(data){
        this.$refs.form.reset();
        this.$emit("emitCloseModal", data);
      },

    },

}
</script>



// WEBPACK FOOTER //
// src/components/procurement/status/statusForm.vue